import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const ImportCustomerFromZoho = ({ handleImportedData,setSelectedData, data=[], selectedData=[], loading=false,}) => {
    const handleSelectItem = (e)=>{
        const extractData = e.value?.map(item=> {
            const { Full_Name, Phone, Email,} = item;
            return { Full_Name, Phone, Email}; 
        });

        if(extractData.length > 0){
            const headers = Object.keys(extractData[0]);
            handleImportedData(headers, extractData )
        }

        setSelectedData(e.value);
        
    }
    return (
     <DataTable
                    loading={loading}
                    value={data}
                    className="skalebot-table"
                    selectionMode="checkbox"
                     selection={selectedData}
                     onSelectionChange={handleSelectItem}
                    scrollable
                    scrollHeight="270px"
                    isDataSelectable={false}
                    paginator
                    rows={30}
                    rowsPerPageOptions={[30, 60, 90, 120]}
                    dragSelection
                >
                    <Column
                        selectionMode="multiple"
                        headerStyle={{ width: "3rem" }}
                        exportable={false}
                        className="text-sm font-normal"
                    />
                    <Column field={'name'} header={'Name'} body={(rowData) => <div>{rowData.Full_Name}</div>} className="text-sm font-normal" />
                    <Column field={'phone'} header={'Mob No.'} body={(rowData) => <div> {rowData.Phone || '-'}</div>} className="text-sm font-normal no-wrap" />
                    <Column field={'email'} header={'Email'} body={(rowData) => <div>{rowData.Email || '-'}</div>} className="text-sm font-normal" />

        </DataTable>)
}

export default ImportCustomerFromZoho;